import { arrayToMap } from "../util";

export const path = "/asset/smartkeyChange";

export const handler = (data, masterData) => {
  return {
    list: data.smartkeyChange,
  };
};



// WEBPACK FOOTER //
// ./lib/masterData/schemas/smartKeyChange.js